import React from 'react';
import { bool } from 'prop-types';
import { selectDocuments } from '@redux/documents/reducers';
import { selectForms } from '@redux/forms/reducers';
import { selectWeblinks } from '@redux/weblinks/selectors';
import { languageFromMetadata, sourceFromMetadata } from '@utils/contentMetadata';
import { documentTypes, formTypes } from '@utils/contentTypes';
import searchDocuments from '@utils/searchDocuments';
import SingleSelect from './SingleSelect';
import MultipleSelect from './MutlipleSelect';
import './style.less';

const defaultContentTypes = [...documentTypes, ...formTypes];

export const filterFunc = (value, comparator, searchTerm) => {
  if (!searchTerm || searchTerm.length < 3) {
    return true;
  }
  const type = value.what ? value.what.split('_')[1] : value.metadata?.type;

  if (type === 'MESSAGE') {
    return comparator(value.title || value.name);
  }

  if (type === 'DOCUMENT' || type === 'VIDEO') {
    return searchDocuments(value, comparator, searchTerm);
  }

  return comparator(value.title || value.name);
};

export function selectContent(state) {
  const selectLanguage = languageFromMetadata(state);
  const selectSource = sourceFromMetadata(state);
  const [documentsLoading, documents] = selectDocuments(state);
  const [formsLoading, forms] = selectForms(state);
  const [weblinksLoading, weblinks] = selectWeblinks(state);

  return [
    documentsLoading || formsLoading || weblinksLoading,
    [
      ...documents.map(document => ({
        ...document,
        metadata: {
          type: document.metadata?.tags?.find(t => t.term === 'VIDEO') ? 'VIDEO' : 'DOCUMENT',
          ...(document.metadata || {}),
          language: selectLanguage(document),
          source: selectSource(document),
        },
      })),
      ...forms.map(form => ({
        ...form,
        id: form.uuid,
        title: form.name,
        metadata: {
          published: form.published,
          ...(form.metadata || {}),
          language: selectLanguage(form),
          source: selectSource(form),
        },
      })),
      ...weblinks.map(weblink => ({
        ...weblink,
        id: weblink.uuid,
        title: weblink.name,
        metadata: {
          type: weblink.type,
          published: weblink.is_available,
        },
      })),
    ],
  ];
}

function SelectContentModal({ multiSelect, ...props }) {
  if (multiSelect) {
    return <MultipleSelect {...props} />;
  }

  return <SingleSelect {...props} />;
}

SelectContentModal.propTypes = {
  multiSelect: bool,
};

SelectContentModal.defaultProps = {
  multiSelect: false,
  contentTypes: defaultContentTypes,
};

export default SelectContentModal;
